export class RetryUtil {
  public static async retry<T>({
                                 asyncFunc,
                                 errorToHandle,
                                 retries = 3,
                                 interval = 1000,
                                 multiplier = 2,
                                 randomize = false,
                                 shouldRetry,
                               }: {
    asyncFunc: () => Promise<T>;
    errorToHandle?: any;
    retries?: number;
    interval?: number;
    multiplier?: number;
    randomize?: boolean;
    shouldRetry?: (error: any) => boolean;
  }): Promise<T> {
    try {
      return await asyncFunc();
    } catch (error) {
      if (
        retries === 0 ||
        (errorToHandle && error !== errorToHandle) ||
        (shouldRetry && !shouldRetry(error))
      ) {
        throw error;
      } else {
        const random = randomize ? Math.random() + 1 : 1;

        const timeout = Math.round(random * interval);
        console.log(`Retrying: timout ${timeout}`);

        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(
              this.retry({
                asyncFunc,
                errorToHandle,
                retries: retries - 1,
                interval: interval * multiplier,
                multiplier,
                randomize,
              }),
            );
          }, timeout);
        });
      }
    }
  }
}
